import { ResultOf, VariablesOf } from '@graphql-typed-document-node/core';
import { useMutation } from '@tanstack/react-query';

import { AppSyncGraphQLError } from 'queries/types';
import { useAccountsClient } from 'services/api';
import { RetroRedeemSaudiRewardsPointsDocument } from 'types/api/account.types';

export const useRetroRedeemSaudiRewardsPoints = () => {
  const retroRedeemSaudiRewardsClient = useAccountsClient();
  const { isPending, isPaused, mutate, error, reset } = useMutation<
    ResultOf<typeof RetroRedeemSaudiRewardsPointsDocument>,
    AppSyncGraphQLError,
    VariablesOf<typeof RetroRedeemSaudiRewardsPointsDocument>
  >({
    mutationFn: ({ redeemToken }) =>
      retroRedeemSaudiRewardsClient.request(
        RetroRedeemSaudiRewardsPointsDocument,
        {
          redeemToken,
        },
      ),
    retry: false,
  });

  return {
    redeemPoints: mutate,
    isLoading: isPending && !isPaused,
    error,
    reset,
  };
};
